"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@dexpenses/core");
class PlaceTypeCategoryCondition {
    constructor(placeTypeCategory) {
        this.placeTypeCategory = placeTypeCategory;
    }
    test(receipt) {
        if (!receipt.place) {
            return false;
        }
        return core_1.applyPlaceTypeMappings(receipt.place.types).has(this.placeTypeCategory);
    }
}
exports.default = PlaceTypeCategoryCondition;
//# sourceMappingURL=PlaceTypeCategoryCondition.js.map